import { defineMessage } from 'services/localization';

export const messages = {
    xero: defineMessage('xero'),
    quickBooks: defineMessage('quickbooks_online'),
    netSuite: defineMessage('netsuite'),
    cin7: defineMessage('cin'),
    title: defineMessage('are_you_sure_you_want_to_skip_connecting_glname'),
    connectButton: defineMessage('connect_your_glname_account'),
    benefitsTitle: defineMessage('without_connecting_you_wont_be_able_to'),
    benefit1: defineMessage('approve_bills_purchase_orders_or_other_documents'),
    benefit2: defineMessage('set_up_complex_approval_rules'),
    benefit3: defineMessage('access_audit_reports'),
    trust1: defineMessage('clients_including_kpmg_bdo_and_deloitte_trust_us'),
    trust2: defineMessage('approvalmax_is_iso_certified_and_gdpr_compliant'),
    learnMore: defineMessage('learn_more'),
    skip: defineMessage('skip'),
};
